import AOS from 'aos';



AOS.init({
  startEvent: 'load',
  once: true,
  easing: 'ease-in-out'
});

